import React from 'react'

function PrintInventoryByProduct() {
  return (
    <div>PrintInventoryByProduct</div>
  )
}

export default PrintInventoryByProduct